import '../components/utils/typography.css'
import '../lib/wdyr'

import { ApolloProvider } from '@apollo/client'
import { AppProps, useApollo } from '@lib/apolloClient'
import setDocumentReferrer from '@lib/setDocumentReferrer'
import { StylesProvider } from '@material-ui/core/styles'
import { appWithTranslation } from 'next-i18next'
import Head from 'next/head'
import { Router } from 'next/router'
import React, { useEffect } from 'react'

function App({ Component, pageProps }: AppProps) {
  const apolloClient = useApollo(pageProps)

  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side')
    if (jssStyles && jssStyles.parentElement) {
      jssStyles.parentElement.removeChild(jssStyles)
    }
  }, [])

  useEffect(() => {
    const routeChangeStart = () => {
      setDocumentReferrer(window.location.href)
    }
    Router.events.on('routeChangeStart', routeChangeStart)

    return () => {
      Router.events.off('routeChangeStart', routeChangeStart)
    }
  }, [])

  return (
    <StylesProvider injectFirst>
      <Head>
        <meta charSet="utf-8" />
        <meta
          content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
          name="viewport"
        />
      </Head>
      <ApolloProvider client={apolloClient}>
        <Component {...pageProps} />
      </ApolloProvider>
    </StylesProvider>
  )
}

export default appWithTranslation(App, {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'pt-BR'],
  },
  /** To avoid issues when deploying to some paas (vercel...) */
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  localePath: require('path').resolve('./public/locales'),
  // // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  // typeof window === 'undefined' ? require('path').resolve('./public/locales') : '/locales',

  react: { useSuspense: false },

  reloadOnPrerender: process.env.NODE_ENV === 'development',
})
